import { graphql } from '../../gql';

export const GET_TOP_N = graphql(`
  query GetTopN(
    $filters: CompensationFilters
    $dim1: Dimension1
    $dim2: CompensationDimension
  ) {
    compensation(filters: $filters, dim1: $dim1, dim2: $dim2) {
      dimension
      metadata {
        id
        shortName
      }
      category {
        metadata {
          id
          shortName
        }
        metrics {
          count
          share
        }
      }
    }
  }
`);
